"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CallStyles {
    constructor() {
        this.containerStyles = {
            position: "fixed",
            zIndex: 9,
            right: "calc(50vw - 100px)",
            width: "200px",
            background: "#fbf8f8",
            boxShadow: "2px 2px 2px 2px lightgrey"
        };
        this.inputFieldStyles = {
            outline: "none",
            width: "100%",
            padding: " 5px",
            fontWeight: "bold",
            fontFamily: "BrandonTextWeb-Bold"
        };
        this.callButtonStyles = {
            border: "none",
            color: "white",
            background: "yellowgreen",
            height: "50px",
            width: "50px",
            borderRadius: "50%",
            fontSize: "20px",
            margin: "0px 10px"
        };
        this.cancelButtonStyles = {
            border: "none",
            color: "white",
            background: "#e4306e",
            height: "50px",
            width: "50px",
            borderRadius: "50%",
            fontSize: "20px",
            margin: "0px 10px"
        };
        this.displayImageStyles = {
            height: "100px",
            width: "100px",
            background: "#00b2e0",
            borderRadius: "50%",
            margin: "10px auto",
            position: "relative",
            color: "#ffffff"
        };
        this.userIconStyles = {
            position: "absolute",
            fontSize: "50px",
            top: "20px",
            right: "30px"
        };
    }
}
exports.CallStyles = CallStyles;
